import { Data, Route, Routes } from '@angular/router';

export enum AppRouteId {
  CUSTOMER_SEARCH = 'CUSTOMER_SEARCH',
  PROFILE = 'PROFILE',
  FEATURE_FLAG = 'FEATURE_FLAG',
}

export interface AppData extends Data {
  routeId: AppRouteId;

  /** The route ID of the parent route. This is used to determine the default back button destination */
  parentRouteId?: AppRouteId;
}

interface RouteWithData<T extends Data> extends Route {
  data: T;
  children?: RouteWithData<T>[];
}

export type AppRoute = RouteWithData<AppData>;

function isAppData(data: Data | undefined): data is AppData {
  return !!data && 'routeId' in data;
}

export function getPathForRouteId(routeId: AppRouteId, routes: Routes): string | undefined {
  const route = routes.find((route) => isAppData(route.data) && route.data.routeId === routeId);
  return route?.path;
}
